export default __webpack_public_path__ + "static/media/fullStar.f509f82b.svg";